import get from 'lodash.get'
import uiJson from '../../../i18n/en.json'

// TODO: load the locale appropriate en.json file
export function t(str: string) {
  return get(uiJson, str)
}
